import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { Avatar, Card, CardContent, Grid, Typography } from '@material-ui/core'
import { orange } from '@material-ui/core/colors'
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined'

// api
import { getPublicAPI } from '../../api'

const TotalHoses = props => {
   const navigate = useNavigate()
   const [hoses, setHoses] = useState(0)

   useEffect(() => {
      const prepareHoses = async () => {
         let data = await getPublicAPI('/get-numbers', { hoses: true })
         if (data?.success) setHoses(data.data)
      }

      prepareHoses()
   }, [])

   return (
      <Card onClick={() => navigate('/app/hoses')} sx={{ height: '100%' }} {...props}>
         <CardContent>
            <Grid container spacing={3} sx={{ justifyContent: 'space-between' }}>
               <Grid item>
                  <Typography color='textSecondary' gutterBottom variant='h6'>
                     TOTAL HOSES
                  </Typography>
                  <Typography color='textPrimary' variant='h3'>
                     {hoses || 0}
                  </Typography>
               </Grid>
               <Grid item>
                  <Avatar
                     sx={{
                        backgroundColor: orange[600],
                        height: 56,
                        width: 56
                     }}
                  >
                     <InsertChartIcon />
                  </Avatar>
               </Grid>
            </Grid>
            {/* <Box sx={{ pt: 3 }}>
            <LinearProgress value={75.5} variant='determinate' />
         </Box> */}
         </CardContent>
      </Card>
   )
}

export default TotalHoses
